'use client';

import { Option, useSort, UseSortProps } from '@liquorice/next-search';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

export interface SortBySelectFieldProps extends UseSortProps {
  label?: string;
}

const defaultOptions: Option[] = [
  { label: 'Default', value: 'combinedTimeAsc ASC' },
  { label: 'Title A-Z', value: 'title ASC' },
  { label: 'Title Z-A', value: 'title DESC' },
  { label: 'Date DESC', value: 'eventTimeAsc DESC' },
];

const SortByField = ({ label = 'Sort By', ...config }: SortBySelectFieldProps) => {
  const { options, orderBy, setOrderBy } = useSort({
    options: defaultOptions,
    ...config,
  });

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    setOrderBy(event.target.value);
  };

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="sort-by-label">{label}</InputLabel>
      <Select
        value={orderBy || defaultOptions[0].value}
        label={label}
        labelId="sort-by-label"
        id="sort-by-select"
        onChange={handleSelectChange}
        fullWidth
        sx={{ fieldset: { borderColor: 'secondary.light' } }}>
        {options.map((item, index) => (
          <MenuItem
            key={item.value}
            children={item.label}
            value={item.value}
            id={`select-${index}`}
          />
        ))}
      </Select>
    </FormControl>
  );
};

export default SortByField;
